import { Reference } from '@apollo/client';

import useMutationWithValidation from '@hooks/useMutationWithValidation';
import {
  GetJourneyWithPlanQuery,
  GoalDestroyDocument,
  GoalDestroyMutation,
  GoalDestroyMutationVariables
} from '@typing/Generated';

const useDestroyGoal = (journey: GetJourneyWithPlanQuery['journey']) => {
  const [destroyGoalMutation] = useMutationWithValidation<GoalDestroyMutation, GoalDestroyMutationVariables>(
    GoalDestroyDocument,
    'goal',
    {
      update: (store, { data }) => {
        const goal = journey?.goals.find(goal => goal.id === data?.goalDestroy?.id);

        if (!journey || !goal) return;

        //
        // For each of the various models on the goal, we need to remove it is only connected to one goal
        // Otherwise we need to remove the goal from the model
        //
        goal.carePlanActionItems.map(actionItem => {
          if (actionItem.goals.length === 1) {
            store.modify({
              fields: {
                carePlanActionItems(cachedRefs: readonly Reference[], { readField }) {
                  return cachedRefs.filter(ref => actionItem.id !== readField('id', ref));
                }
              },
              id: store.identify({ ...journey })
            });
          } else {
            store.modify({
              fields: {
                goals(cachedRefs: readonly Reference[], { readField }) {
                  return cachedRefs.filter(ref => goal.id !== readField('id', ref));
                }
              },
              id: store.identify({ ...actionItem })
            });
          }
        });

        goal.tasks.map(task => {
          if (task.goals.length === 1) {
            store.modify({
              fields: {
                clientVisibleTasks(cachedRefs: readonly Reference[], { readField }) {
                  return cachedRefs.filter(ref => task.id !== readField('id', ref));
                }
              },
              id: store.identify({ ...journey })
            });
          } else {
            store.modify({
              fields: {
                goals(cachedRefs: readonly Reference[], { readField }) {
                  return cachedRefs.filter(ref => goal.id !== readField('id', ref));
                }
              },
              id: store.identify({ ...task })
            });
          }
        });

        goal.worksheets
          .filter(worksheet => worksheet.goals.length === 1)
          .map(worksheet => {
            if (worksheet.goals.length === 1) {
              store.modify({
                fields: {
                  worksheets(cachedRefs: readonly Reference[], { readField }) {
                    return cachedRefs.filter(ref => worksheet.id !== readField('id', ref));
                  }
                },
                id: store.identify({ ...journey })
              });
            } else {
              store.modify({
                fields: {
                  goals(cachedRefs: readonly Reference[], { readField }) {
                    return cachedRefs.filter(ref => goal.id !== readField('id', ref));
                  }
                },
                id: store.identify({ ...worksheet })
              });
            }
          });

        // Remove the goal from the journey
        store.modify({
          fields: {
            goals(cachedRefs: readonly Reference[], { readField }) {
              return cachedRefs.filter(ref => goal.id !== readField('id', ref));
            }
          },
          id: store.identify({ ...journey })
        });
      }
    }
  );
  return destroyGoalMutation;
};

export default useDestroyGoal;
